import React from 'react';
import Grid from '@mui/material/Grid2';
import { Chip } from '@mui/material';

const Tags = ({ tags }) => {
	return (
		<Grid container spacing={1}>
			{tags.map((tag) => (
				<Grid size='auto' key={tag}>
					<Chip size='small' label={`#${tag}`} sx={{ fontFamily: 'Lato' }} />
				</Grid>
			))}
		</Grid>
	);
};

export default Tags;
